/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `active` - Active
 * * `canceled` - Canceled
 * * `incomplete` - Incomplete
 * * `incomplete_expired` - Incomplete Expired
 * * `past_due` - Past due
 * * `trialing` - Trialing
 * * `unpaid` - Unpaid
 * @export
 */
export const StripeSubscriptionStatusEnum = {
    Active: 'active',
    Canceled: 'canceled',
    Incomplete: 'incomplete',
    IncompleteExpired: 'incomplete_expired',
    PastDue: 'past_due',
    Trialing: 'trialing',
    Unpaid: 'unpaid'
} as const;
export type StripeSubscriptionStatusEnum = typeof StripeSubscriptionStatusEnum[keyof typeof StripeSubscriptionStatusEnum];


export function instanceOfStripeSubscriptionStatusEnum(value: any): boolean {
    for (const key in StripeSubscriptionStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(StripeSubscriptionStatusEnum, key)) {
            if (StripeSubscriptionStatusEnum[key as keyof typeof StripeSubscriptionStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StripeSubscriptionStatusEnumFromJSON(json: any): StripeSubscriptionStatusEnum {
    return StripeSubscriptionStatusEnumFromJSONTyped(json, false);
}

export function StripeSubscriptionStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeSubscriptionStatusEnum {
    return json as StripeSubscriptionStatusEnum;
}

export function StripeSubscriptionStatusEnumToJSON(value?: StripeSubscriptionStatusEnum | null): any {
    return value as any;
}

export function StripeSubscriptionStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): StripeSubscriptionStatusEnum {
    return value as StripeSubscriptionStatusEnum;
}
